import { render } from "./TressDivider2.vue?vue&type=template&id=054e5c35&scoped=true"
const script = {}

import "./TressDivider2.vue?vue&type=style&index=0&id=054e5c35&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-054e5c35"]])

export default __exports__